import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

import useBids from 'hooks/useBids';
import useProperties from 'hooks/useProperties';

import { addBidRoutine } from 'state/bid/bid.routines';
import { hideDialog, showDialog } from 'state/dialog/dialog.reducer';

import BidDisclaimerDialog from 'components/bid-disclaimer-dialog/bid-disclaimer-dialog.component';

import Page from 'components/page/page.component';
import BidForm from 'components/bid-form/bid-form.component';

const Bidding = ({ history, location }) => {
    const [maxBidForProperty, setMaxBidForProperty] = useState(undefined);
    const [property, setProperty] = useState(undefined);

    const dispatch = useDispatch();
    const { getMaxBidForProperty } = useBids();
    const { properties } = useProperties();

    const params = queryString.parse(location.search);

    const handleSubmitBid = (bid) => {
        if (dispatch && bid) {
            dispatch(
                showDialog({
                    render: (props) => <BidDisclaimerDialog {...props} />,
                    props: {
                        bid,
                        onClose: () => {
                            dispatch(hideDialog());
                        },
                        onSubmitBidClick: () => {
                            dispatch(hideDialog());
                            dispatch(
                                addBidRoutine({
                                    bid,
                                    onSuccess: () => {
                                        history.push(`/properties`);
                                    }
                                })
                            );
                        }
                    }
                })
            );
        }
    };

    useEffect(() => {
        if (params && params.parcelNumber) {
            setMaxBidForProperty(getMaxBidForProperty({ property: params }));
        }
    }, [params]);

    useEffect(() => {
        if (params && properties) {
            setProperty(properties.find(({ parcelNumber }) => parcelNumber === params.parcelNumber));
        }
    }, [params, properties]);

    return (
        <Page
            heroTitle="Bidding Made Simple"
            heroText="Use the form below to submit a bid for the property you are interested in."
            heroSize="small"
        >
            <BidForm
                onSubmit={handleSubmitBid}
                bid={{ ...params }}
                currentHighBid={maxBidForProperty}
                startingBid={property?.startingBid}
            />
        </Page>
    );
};

export default withRouter(Bidding);
